<template>
    <img :src="order.feature_image ? order.feature_image : $global.no_image" alt="Car Image" width="546" height="364" />
    <h2>{{ order.make.name }} {{ order.car_model.name }} {{ order.version ?? '' }}</h2>
    <div class="payment-right-price">
        <div v-if="order.without_vat === 1">
            <p>Μερικό σύνολο:</p>
            <p>{{ order.partial_price.toLocaleString('el-GR') }}€</p>
        </div>
        <div v-if="payment_option === 'Online χρηματοδότηση'">
            <p>Έξοδα χρηματοδότησης:</p>
            <p>{{ order.finance ? order.finance : 0 }}€</p>
        </div>
        <div>
            <p>Κόστος μεταφοράς:</p>
            <p>{{ order.shipping ? order.shipping : 0 }}€</p>
        </div>
        <div v-if="order.without_vat === 1">
            <p>ΦΠΑ:</p>
            <p>{{ order.final_vat.toLocaleString('el-GR') }}€</p>
        </div>
        <div v-if="coupon.new_price">
            <p>Έκπτωση ({{ coupon.coupon_code }}):</p>
            <p>-{{ (order.final_price - coupon.new_price).toLocaleString('el-GR') }}€</p>
        </div>
        <!-- <template v-if="payment_option === 'Online κράτηση'">
            <div><h3><strong>Τι κερδίζεις:</strong></h3></div>
            <div>
                <p>Τέλη Κυκλοφορίας:</p>
                <p>Δωρεάν</p>
            </div>
            <div>
                <p>Μεταβίβαση Οχήματος:</p>
                <p>Δωρεάν</p>
            </div>
            <div>
                <p>6 Μήνες Ασφάλιση:</p>
                <p>Δωρεάν</p>
            </div>
            <div>
                <p>6 Μήνες Οδική Βοήθεια:</p>
                <p>Δωρεάν</p>
            </div>
        </template> -->
        <div>
            <p>Σύνολο:</p>
            <p>{{ coupon.new_price ? coupon.new_price.toLocaleString('el-GR') : order.final_price.toLocaleString('el-GR') }}€</p>
        </div>
    </div>
    <div class="payment-right-total">
        <p v-if="payment_option === 'Online κράτηση' || paid">{{ paid ? `Ποσό που κρατήθηκε` : payment_option === 'Online χρηματοδότηση' ? `Ποσό χρηματοδότησης` : `Ποσό κράτησης` }}</p>
        <p v-if="payment_option === 'Online κράτηση' || paid">{{ payment_selection === 2 && payment_option === 'Online χρηματοδότηση' ? 
            ( order.final_price - ( data.downPayment > order.final_price ? order.final_price : data.downPayment ) ).toLocaleString('el-GR')
            : order.amount.toLocaleString('el-GR') }}€</p>
    </div>
</template>

<script>
    export default {
        props: {
            order: Object,
            paid: Boolean,
            coupon: Object,
            data: Object,
            payment_option: String,
            payment_selection: String
        },
        setup(props, { slots, attrs }) {
        },
        data() {
            return {
            }
        },
        methods: {
        },
    }
</script>